import React from "react";
import EmptyMessageState from "static/images/EmptyMessageState.svg";

export const EmptyStateIndicator = () => {
  return (
    <div className="t-h-full t-w-full t-flex t-flex-col t-items-center t-justify-center">
      <img src={EmptyMessageState} alt="EmptyMessageState" />
      <div className="t-text-title-h2-bold t-text-text-30 t-mt-7">
        No messages yet
      </div>
      <div className="t-w-40 t-text-center t-text-body-sm t-text-neutral-50 t-mt-1">
        Feel free to share, ask, or get task updates here
      </div>
    </div>
  );
};
